// Section Shopify Shopify.theme editor events

$(document).on("shopify:section:reorder", function (e) {
  var $target = $(e.target);
  var $parentSection = $("#shopify-section-" + e.detail.sectionId);

  if (Shopify.theme.jsHeader.enable_overlay == true) {
    Shopify.theme.jsHeader.unload();
    Shopify.theme.jsHeader.updateOverlayStyle(
      Shopify.theme.jsHeader.sectionUnderlayIsImage()
    );
  }
});

$(document).on("shopify:section:load", function (e) {
  // Shopify section as jQuery object
  var $section = $(e.target);

  // Vanilla js selection of Shopify section
  var section = document.getElementById(
    "shopify-section-" + e.detail.sectionId
  );

  // Blocks within section
  var $jsSectionBlocks = $section.find(".shopify-section[class*=js]");

  var sectionObjectUrl = $section
    .find("[data-theme-editor-load-script]")
    .attr("src");

  // Check classes on schema and look for js (eg. jsMap)
  for (var i = 0; i < section.classList.length; i++) {
    if (section.classList[i].substring(0, 2) === "js") {
      var triggerClass = section.classList[i];

      // Check to see if section script exists
      if (typeof Shopify.theme[triggerClass] == "undefined") {
        // make AJAX call to load script
        Shopify.theme.loadScript(triggerClass, sectionObjectUrl, function () {
          Shopify.theme[triggerClass].init($(section));
        });
      } else {
        if (Shopify.theme[triggerClass]) {
          Shopify.theme[triggerClass].init($(section));
        } else {
        }
      }
    }
  }

  // Check classes on block element and look for js (eg. jsMap)
  if ($jsSectionBlocks.length > 0) {
    var $jsSectionBlockNames = $jsSectionBlocks.each(function () {
      for (var i = 0; i < this.classList.length; i++) {
        if (this.classList[i].substring(0, 2) === "js") {
          var triggerClass = this.classList[i];
          var $block = $("." + triggerClass);
          var blockUrl = $block
            .find("[data-theme-editor-load-script]")
            .attr("src");

          // Check to see if section script exists
          if (typeof Shopify.theme[triggerClass] == "undefined") {
            // make AJAX call to load script
            Shopify.theme.loadScript(triggerClass, blockUrl, function () {
              Shopify.theme[triggerClass].init($block);
            });
          } else {
            if (Shopify.theme[triggerClass]) {
              Shopify.theme[triggerClass].init($(this));
            } else {
            }
          }
        }
      }
    });
  }

  // Load video feature
  Shopify.theme.video.init();

  // Scrolling animations
  Shopify.theme.animation.init();

  // Initialize reviews
  Shopify.theme.productReviews.init();

  // Object Fit Images
  Shopify.theme.objectFitImages.init();

  // Infinite scrolling
  Shopify.theme.infiniteScroll.init();

  // Disclosure menus
  Shopify.theme.disclosure.enable();

  // Search
  $(document).on("click", "[data-show-search-trigger]", function () {
    Shopify.theme.jsHeader.showSearch();
  });

  $(".search-overlay__close").on("click", function () {
    Shopify.theme.jsHeader.hideSearch();
  });

  if (Shopify.theme_settings.enable_autocomplete == true) {
    Shopify.theme.predictiveSearch.init();
  }
  // Product review scroll
  Shopify.theme.productReviews.productReviewScroll();
});

$(document).on("shopify:section:unload", function (e) {
  // Shopify section as jQuery object
  var $section = $(e.target);

  // Vanilla js selection of Shopify section
  var section = document.getElementById(
    "shopify-section-" + e.detail.sectionId
  );

  // Blocks within section
  var $jsSectionBlocks = $section.find(".shopify-section[class*=js]");

  // Check classes on schema and look for js (eg. jsMap)
  for (var i = 0; i < section.classList.length; i++) {
    if (section.classList[i].substring(0, 2) === "js") {
      var triggerClass = section.classList[i];
      if (Shopify.theme[triggerClass]) {
        Shopify.theme[triggerClass].unload($(section));
      } else {
      }
    }
  }

  // Check classes on block element and look for js (eg. jsMap)
  if ($jsSectionBlocks.length > 0) {
    var $jsSectionBlockNames = $jsSectionBlocks.each(function () {
      for (var i = 0; i < this.classList.length; i++) {
        if (this.classList[i].substring(0, 2) === "js") {
          var triggerClass = this.classList[i];
          if (Shopify.theme[triggerClass]) {
            Shopify.theme[triggerClass].unload($(this));
          } else {
          }
        }
      }
    });
  }

  // Scrolling animations
  Shopify.theme.animation.unload($section);

  // QuantityBox
  Shopify.theme.quantityBox.unload($section);

  // Infinite scrolling
  Shopify.theme.infiniteScroll.unload($section);

  // Disclosure menus
  Shopify.theme.disclosure.enable();
});

$(document).on("shopify:section:select", function (e) {
  // Shopify section as jQuery object
  var $section = $(e.target);

  // Vanilla js selection of Shopify section
  var section = document.getElementById(
    "shopify-section-" + e.detail.sectionId
  );

  // Force show state when section is selected in theme editor
  for (var i = 0; i < section.classList.length; i++) {
    if (section.classList[i].substring(0, 2) === "js") {
      var triggerClass = section.classList[i];
      if (Shopify.theme[triggerClass].showThemeEditorState) {
        Shopify.theme[triggerClass].showThemeEditorState(
          e.detail.sectionId,
          $section
        );
      }
    }
  }

  // Predictive search
  if (Shopify.theme_settings.enable_autocomplete == true) {
    Shopify.theme.predictiveSearch.init();
  }

  if ($(".tabs").length > 0) {
    Shopify.theme.tabs.enableTabs();
  }

  if (isScreenSizeLarge() && Shopify.theme.jsHeader.enable_overlay === true) {
    Shopify.theme.jsHeader.updateOverlayStyle(
      Shopify.theme.jsHeader.sectionUnderlayIsImage()
    );
  }

  if ($(".block__recommended-products").length > 0) {
    var $productPage = $(".block__recommended-products").parents(
      ".product-page"
    );
    Shopify.theme.jsRecommendedProducts.init($productPage);
  }
});

$(document).on("shopify:section:deselect", function (e) {
  // Shopify section as jQuery object
  var $section = $(e.target);

  // Vanilla js selection of Shopify section
  var section = document.getElementById(
    "shopify-section-" + e.detail.sectionId
  );

  // Force hide state when section is selected in theme editor
  for (var i = 0; i < section.classList.length; i++) {
    if (section.classList[i].substring(0, 2) === "js") {
      var triggerClass = section.classList[i];
      if (Shopify.theme[triggerClass].showThemeEditorState) {
        Shopify.theme[triggerClass].hideThemeEditorState(
          e.detail.sectionId,
          $(section)
        );
      }
    }
  }
});

// Block Shopify Shopify.theme editor events

$(document).on("shopify:block:select", function (e) {
  var blockId = e.detail.blockId;
  var $parentSection = $("#shopify-section-" + e.detail.sectionId);
  var $block = $("#shopify-section-" + blockId);

  if ($(".jsFeaturedPromos").length > 0) {
    Shopify.theme.jsFeaturedPromos.blockSelect($parentSection, blockId);
  }

  if ($(".jsSlideshowWithText").length > 0) {
    Shopify.theme.jsSlideshowWithText.blockSelect($parentSection, blockId);
  }

  if ($(".jsSlideshowClassic").length > 0) {
    Shopify.theme.jsSlideshowClassic.blockSelect($parentSection, blockId);
  }

  if ($(".jsTestimonials").length > 0) {
    Shopify.theme.jsTestimonials.blockSelect($parentSection, blockId);
  }

  // Sidebar collection multi-tag filter
  if ($block.hasClass("sidebar__block")) {
    var $toggleBtn = $block.find('[data-sidebar-block__toggle="closed"]');
    if ($toggleBtn) {
      Shopify.theme.jsSidebar.openSidebarBlock($toggleBtn);
    }
  }

  // Predictive search
  if (Shopify.theme_settings.enable_autocomplete == true) {
    Shopify.theme.predictiveSearch.init();
  }

  // Scrolling animations
  Shopify.theme.animation.init();

  // Object Fit Images
  Shopify.theme.objectFitImages.init();
});

$(document).on("shopify:block:deselect", function (e) {
  var $block = $("#shopify-section-" + e.detail.blockId);

  if ($block.hasClass("sidebar__block")) {
    var $toggleBtn = $block.find('[data-sidebar-block__toggle="open"]');
    if ($toggleBtn) {
      Shopify.theme.jsSidebar.closeSidebarBlock($toggleBtn);
    }
  }
});

$(document).on("shopify:block:load", function (e) {});

// Document ready
$(function () {
  if (!Shopify.designMode) {
    // This will not happen in the theme editor
    Shopify.cookie.addCookie();

    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState === "hidden") {
        Shopify.cookie.addCookie();
      } else {
        Shopify.cookie.addCookie();
      }
    });

    Shopify.theme.setServerTime();

    Shopify.getProfile = new CustomEvent("profileUpdate", {
      detail: {},
    });

    if (!Shopify.theme_settings.userLoggedIn) {
      const app = Shopify.shop.split(".")[0];
      const hostUrl = window.location.host.split(".");
      const shopifyDomain =
        hostUrl[0].indexOf("beta-") > -1
          ? window.location.host
          : `.${hostUrl[1]}.${hostUrl[2]}`;
      Cookies.remove(`${app}-info`, {
        domain: shopifyDomain,
      });
    }

    Shopify.contentCreator.pastApi.getUserProfile({
      fn: (res = {}) => {
        Shopify.profile = res.data;
        document.dispatchEvent(Shopify.getProfile);
      },
      error: (err) => {
        console.log(err);
      },
      params: { email: "" },
    });
  }

  const u = location.href;
  if (u.indexOf("beta-eufy") > 0) {
    window.setInterval(() => {
      const s_cookiesDiff = localStorage.getItem("cookiesDiff");
      const s_cookiesPre = localStorage.getItem("cookiesPre");
      const cookiesDiff = s_cookiesDiff ? JSON.parse(s_cookiesDiff) : [];
      const cookiesPre = s_cookiesPre ? JSON.parse(s_cookiesPre) : [];
      const c = Cookies.get();
      const previous = cookiesPre[0] || {};
      const arr = { previous: Object.keys(previous), c: Object.keys(c) };
      const value = {};
      arr.previous.forEach((v) => {
        if (previous[v] !== c[v]) {
          value[v] = c[v];
        }
      });
      arr.c.forEach((v) => {
        if (!previous[v] && c[v]) {
          value[v] = c[v];
        }
      });
      if (value && JSON.stringify(value) !== "{}") {
        value.url = location.href;
        cookiesDiff.unshift(value);
        cookiesPre.unshift(c);
      }
      if (cookiesPre.length > 10) cookiesPre.pop();
      if (cookiesDiff.length > 10) cookiesDiff.pop();
      localStorage.setItem("cookiesDiff", JSON.stringify(cookiesDiff));
      localStorage.setItem("cookiesPre", JSON.stringify(cookiesPre));
    }, 800);
  }

  var $jsSections = $(".shopify-section[class*=js]");

  // Loop through sections with js classes and load them in
  var $jsSectionNames = $jsSections.each(function () {
    for (var i = 0; i < this.classList.length; i++) {
      if (this.classList[i].substring(0, 2) === "js") {
        var triggerClass = this.classList[i];
        if (Shopify.theme[triggerClass]) {
          Shopify.theme[triggerClass].init($(this));
        } else {
        }
      }
    }
  });

  var resizeTimer;

  $(window).on("resize", function (e) {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      Shopify.theme.objectFitImages.calculateAspectRatio();

      if (Shopify.theme.jsHeader?.header_layout === "vertical") {
        Shopify.theme.predictiveSearch.alignVerticalSearch();
      }

      if (!isScreenSizeLarge()) {
        // When 798 or less
        Shopify.theme.mobileMenu.init();
      } else {
        // When larger than 798
        Shopify.theme.mobileMenu?.unload();
        Shopify.theme.jsAnnouncementBar?.addCenterAlignment();

        // Swatches
        if (Shopify.theme_settings.product_form_style == "swatches") {
          Shopify.theme.thumbnail.enableSwatches();
        }
      }
    }, 250);
  });

  //Enable plyr
  Shopify.theme.video.init();

  // Predictive search
  if (Shopify.theme_settings.enable_autocomplete == true) {
    Shopify.theme.predictiveSearch.init();
  }

  Shopify.theme.dropdownMenu();

  Shopify.theme.disclosure.enable();

  // Scrolling animations
  Shopify.theme.animation.init();

  // QuantityBox
  Shopify.theme.quantityBox.init();

  /* Show secondary image on hover */
  if (Shopify.theme_settings.show_secondary_image == true) {
    Shopify.theme.thumbnail.showVariantImage();
  }

  // Collection swatches
  if (Shopify.theme_settings.show_collection_swatches) {
    Shopify.theme.thumbnail.enableSwatches();
  }

  // Quick shop
  if (Shopify.theme_settings.enable_quickshop) {
    Shopify.theme.thumbnail.showQuickShop();
  }

  // Currency converter
  if (Currency.show_multiple_currencies || Currency.native_multi_currency) {
    Shopify.theme.currencyConverter.init();
  }

  //Infinite scrolling
  if ($("[data-custom-pagination]").length) {
    Shopify.theme.infiniteScroll.init();
  }

  //Select event for native multi currency checkout
  $(".shopify-currency-form select").on("change", function () {
    $(this).parents("form").submit();
  });

  // Tabs
  if ($(".tabs").length > 0) {
    Shopify.theme.tabs.enableTabs();
  }

  // Additional checkout buttons
  if (!isScreenSizeLarge()) {
    $(".additional-checkout-buttons").addClass(
      "additional-checkout-buttons--vertical"
    );
  }

  // Accordion
  if ($(".accordion, [data-cc-accordion]").length > 0) {
    Shopify.contentCreator.accordion.init();
  }

  // Backwards compatiblity for Flexslider
  if ($(".slider, .flexslider").length > 0) {
    Shopify.contentCreator.slideshow.init();
  }

  // Object Fit Images
  Shopify.theme.objectFitImages.init();

  // Responsive Video
  Shopify.theme.responsiveVideo.init();

  // Flickity IOS Fix
  Shopify.theme.flickityIosFix();

  // Product review scroll
  Shopify.theme.productReviews.productReviewScroll();

  // seo init
  var alternate = document.querySelectorAll('link[rel="alternate"]');
  if (alternate) {
    var pathname = document.location.pathname;
    alternate.forEach((v) => {
      var h = v.href;
      v.href = h.replace("/hreflang-pathname", pathname);
    });
  }

  document.addEventListener("readystatechange", (e) => {
    if (e.target.readyState === "complete") {
      Shopify.theme.jsFixedMessage && Shopify.theme.jsFixedMessage.init();
    }
  });

  let mbtabSwiper;

  function emptyHash() {
    // location.hash = "";
    history.pushState(
      "",
      document.title,
      window.location.pathname + window.location.search
    );
  }

  $("[data-pc-mega-subtab]").hover(function () {
    const idx = $(this).index();
    const $contain = $(this)
      .parents(".mega-subtab-contain")
      .siblings(".mega-product-contain");
    $(this).addClass("actived").siblings().removeClass("actived");
    $contain.eq(idx).addClass("actived").siblings().removeClass("actived");
  });

  $("[data-mega-tab-item]").hover(function () {
    const $item = $(this).parents(".mega-tab-item");
    const idx = $item.index();
    const $mege = $item.parents(".tab-mage-wrapper");
    $item.addClass("actived").siblings().removeClass("actived");
    $mege
      .find(".mega-tab-content-item")
      .eq(idx)
      .addClass("actived")
      .siblings()
      .removeClass("actived");
  });

  $(".main-nav-item").hover(
    function (e) {
      const $link = $(this).find(".main-nav-link");
      const href = $link.attr("href");
      const $searchMega = $(".search-mega-wrapper");

      if ($searchMega.hasClass("actived")) return;
      // $("#shopify-section-header-v3").css("z-index", 50);
      $(".tab-mage-wrapper").removeClass("actived");
      $(".main-nav-link").removeClass("actived");
      $link.next(".tab-mage-wrapper").addClass("actived");

      $link.addClass("actived");
      if ($(this).hasClass("main-nav-small-item")) {
        const offset =
          $(this)[0].offsetLeft +
          $(this).width() / 2 -
          $(this).find(".mega-content").width() / 2;
        $(this).find(".mega-content").css("left", offset);
      }
    },
    function () {
      // $("#shopify-section-header-v3").css("z-index", "");
    }
  );

  // start_ai_generated
  $(".header-pc").hover(
    function () {
      $("#shopify-section-header-v3").css("z-index", 50);
    },
    function () {
      const $searchMega = $(".search-mega-wrapper");
      if ($searchMega.hasClass("actived")) return;
      $("#shopify-section-header-v3").css("z-index", "");
    }
  );
  // end_ai_generated

  $(".js-main-nav-item").hover(function (e) {
    const idx = $(this).index();
    location.hash = `navimenu_${idx + 1}_copy`;
  });

  $(".js-main-nav-small-item").hover(function (e) {
    const idx = $(this).index();
    const len = $(".js-main-nav-item").length;
    location.hash = `navimenu_${idx + len + 1}_copy`;
  });

  $(".js-nav-empty-bar").hover(function () {
    $(".main-nav-link").removeClass("actived");
    $(".tab-mage-wrapper").removeClass("actived");
    emptyHash();
  });

  $(".js-tab-mega-mask").hover(function () {
    $(".tab-mage-wrapper").removeClass("actived");
    $(".main-nav-link").removeClass("actived");
    emptyHash();
  });

  $(".main-nav").hover(
    function () {
      $("[data-mega-img]").each(function () {
        const src = $(this).attr("data-src");
        if (src) {
          $(this).attr("src", src);
          $(this).removeAttr("data-src");
          $(this).removeAttr("data-mega-img");
        }
      });
    },
    function () {
      $(".tab-mage-wrapper").removeClass("actived");
      $(".main-nav-link").removeClass("actived");
      emptyHash();
    }
  );

  $(".header-menu-icon").hover(function () {
    $(".tab-mage-wrapper").removeClass("actived");
    $(".main-nav-link").removeClass("actived");
    emptyHash();
  });

  $(".js-header-user-btn").hover(
    function () {
      const $searchMega = $(".search-mega-wrapper");
      if ($searchMega.hasClass("actived")) return;
      $(this).addClass("actived");
      // $("#shopify-section-header-v3").css("z-index", 50);
    },
    function () {
      const $searchMega = $(".search-mega-wrapper");
      if ($searchMega.hasClass("actived")) return;
      $(this).removeClass("actived");
      // $("#shopify-section-header-v3").css("z-index", "");
    }
  );

  function handleRegistrationsModelStatus() {
    // start_ai_generated
    $(".registrations-model").removeClass("hidden");
    $(".registrations-coupons").addClass("hidden");
    $(".registrations-password-login").addClass("hidden");
    $(".registrations-reminder").addClass("hidden");
    $(".registrations-subscribe-sms").addClass("hidden");
    $(".registrations-activate").addClass("hidden");
    // end_ai_generated
  }

  // start_ai_generated
  const countryCode = $("#headerV3").data("country-code");
  const countrys = ["us", "ca", "uk", "de", "nl", "eu"];
  // end_ai_generated
  if (countrys.includes(countryCode)) {
    $(
      ".customer-dropmenu-link-signup, .js-mob-sinUp, .product-priority-link"
    ).on("click", function (e) {
      e.preventDefault();
      // start_ai_generated
      $(".registrations-main").removeClass("hidden");
      $(".registrations-quick-login").addClass("hidden");
      handleRegistrationsModelStatus();
      $(".rsm-form")[0].reset();
      $(".js-rsm-input").removeClass("input-error");
      $(".js-email-error").text("");
      $(".js-verify-account-error").addClass("hidden");
      // end_ai_generated
    });

    $(".customer-dropmenu-link-login, .js-mob-login").on("click", function (e) {
      e.preventDefault();
      // start_ai_generated
      $(".registrations-main").addClass("hidden");
      $(".registrations-quick-login").removeClass("hidden");
      handleRegistrationsModelStatus();
      $(".rsql-form")[0].reset();
      $(".js-email-error").text("");
      $(".js-rsql-input").removeClass("input-error");
      // end_ai_generated
    });
  }

  $(".js-dropmenu-mask").hover(function () {
    $(".js-header-user-btn").removeClass("actived");
  });

  $(".js-search-action").on("click", function () {
    const $mega = $(this)
      .parents(".header-search-btn")
      .find(".search-mega-wrapper");
    if ($mega.hasClass("actived")) {
      $mega.removeClass("actived");
      $("#headerV3").removeClass("actived");
      $(".header-search-icon").removeClass("actived");
      // $("#shopify-section-header-v3").css("z-index", "");
    } else {
      $mega.addClass("actived");
      $("#headerV3").addClass("actived");
      $(".header-search-icon").addClass("actived");
      $("#shopify-section-header-v3").css("z-index", 50);
    }
  });

  $(".js-search-btn").on("click", function () {
    const val = $(this).siblings(".js-search-input").val();
    location.href = `/search?q=${val}`;
  });

  $(".mega-search-input,.header-mob-search").on("keyup", function (e) {
    const val = $(this).val();
    if (e.which == "13") {
      location.href = `/search?q=${val}`;
    }
  });

  $(".header-mob-search").on("blur", function () {
    const val = $(this).val();
    if (val) location.href = `/search?q=${val}`;
  });

  $(".js-header-live").each(function () {
    const live = Shopify.eufyV3.header.filter(
      (item) => item.type === "live"
    )[0];
    const durs = (Shopify.livestream && Shopify.livestream.list) || {};
    if (durs.length) {
      durs.map((item) => {
        const s = item.reminder_start;
        const e = item.reminder_end;
        const now = new Date().getTime();
        const startTime = Shopify.theme.icsDate2jsDate(s);
        const endTime = Shopify.theme.icsDate2jsDate(e);
        if ((now >= startTime && !e) || (now >= startTime && now <= endTime)) {
          $(this).addClass("actived");
        }
      });
    } else {
      if (live) {
        const { durations } = live;
        durations.map(({ start, end }) => {
          if (start) {
            const s = start.replace(/-/g, "/");
            const e = end.replace(/-/g, "/");
            const now = new Date().getTime();
            const startTime = new Date(s).getTime();
            const endTime = new Date(e).getTime();
            if (
              (now >= startTime && !e) ||
              (now >= startTime && now <= endTime)
            ) {
              $(this).addClass("actived");
            }
          }
        });
      }
    }
  });

  $("[data-mob-nav-trigger]").on("click", function () {
    const $target = $(".header-mob-nav");
    const $subNav = $(".header-mob-sub-nav");
    const $thdNav = $(".header-mob-thd-nav");
    const $linksNav = $(".header-mob-links-nav");
    const $searchWrap = $(".header-mob-search-wrap");

    toggleClass(
      $target,
      "actived",
      () => {
        location.hash = "navi";
      },
      () => {
        emptyHash();
      }
    );
    toggleLock();
    $subNav.removeClass("actived");
    $thdNav.removeClass("actived");
    $linksNav.removeClass("actived");
    $searchWrap.removeClass("actived");
  });

  $("[data-main-mob-search-trigger]").on("click", function () {
    const $target = $(".header-mob-search-wrap");
    toggleClass($target, "actived");
    if ($(".header-mob-search-wrap").hasClass("actived")) {
      $(".localeswitcher-popup").hide();
    } else {
      $(".localeswitcher-popup").show();
    }
  });

  $("[data-mob-sub-nav-trigger]").on("click", function () {
    const $subNav = $(".header-mob-sub-nav");
    $subNav.removeClass("actived");
    // start_ai_generated
    location.hash = "navi";
    // end_ai_generated
    animateNavs($(".header-mob-main-nav"));
  });

  $("[data-mob-links-nav-trigger]").on("click", function () {
    const $linksNav = $(".header-mob-links-nav");
    $linksNav.removeClass("actived");
    // start_ai_generated
    location.hash = "navi";
    // end_ai_generated
    animateNavs($(".header-mob-main-nav"));
  });

  $("[data-mob-thd-nav-trigger]").on("click", function () {
    const $thdNav = $(".header-mob-thd-nav");
    const label = $(".header-mob-sub-nav").data("label");
    // start_ai_generated
    location.hash = `navi_2_${label.toLowerCase().replaceAll(" ", "_")}`;
    // end_ai_generated
    $thdNav.removeClass("actived");
    animateNavs($(".header-mob-sub-nav"));
  });

  $("[data-mob-deals-nav-trigger]").on("click", function () {
    const $dealsNav = $(".header-mob-deals-nav");
    $dealsNav.removeClass("actived");
    // start_ai_generated
    location.hash = "navi";
    // end_ai_generated
    animateNavs($(".header-mob-main-nav"));
  });

  $("[data-mob-main-tab]").on("click", function () {
    const label = $(this).data("mob-main-tab");
    const idx = $(this).index();
    const $subNav = $(".header-mob-sub-nav");

    setMobSubNav(label, idx);
    // start_ai_generated
    toggleClass(
      $subNav,
      "actived",
      () => {
        location.hash = `navi_2_${label.toLowerCase().replaceAll(" ", "_")}`;
      },
      () => {
        location.hash = "navi";
      }
    );
    // end_ai_generated
  });

  $("[data-mob-main-deals]").on("click", function () {
    const label = $(this).data("mob-main-deals");
    const idx = $(this).index();
    const $dealsNav = $(".header-mob-deals-nav");

    setMobDealNav(label, idx);
    // start_ai_generated
    toggleClass(
      $dealsNav,
      "actived",
      () => {
        location.hash = `navi_2_${label.toLowerCase().replaceAll(" ", "_")}`;
      },
      () => {
        location.hash = "navi";
      }
    );
    // end_ai_generated
  });

  $("[data-mob-main-links]").on("click", function () {
    const label = $(this).data("mob-main-links");
    const idx = $(this).index();
    const $linksNav = $(".header-mob-links-nav");

    setMobLinksNav(label, idx);
    // start_ai_generated
    toggleClass(
      $linksNav,
      "actived",
      () => {
        location.hash = `navi_2_${label.toLowerCase().replaceAll(" ", "_")}`;
      },
      () => {
        location.hash = "navi";
      }
    );
    // end_ai_generated
  });

  $(".header-mob-sub-nav").on("click", "[data-mob-sub-nav]", function () {
    const label = $(this).data("mob-sub-nav");
    const idx = $(this).index();
    const $thdNav = $(".header-mob-thd-nav");

    setMobThdNav(label, idx);
    // start_ai_generated
    toggleClass(
      $thdNav,
      "actived",
      () => {
        location.hash = `navi_3_${label.toLowerCase().replaceAll(" ", "_")}`;
      },
      () => {
        location.hash = "navi";
      }
    );
    // end_ai_generated
  });

  $(".header-mob-thd-nav").on("click", ".mob-product-tab-item", function () {
    const idx = $(this).index();
    $(this).addClass("actived").siblings().removeClass("actived");
    $(".mob-nav-product-warpper")
      .eq(idx)
      .addClass("actived")
      .siblings()
      .removeClass("actived");
  });

  function toggleClass(t, c, s, f) {
    if (t.hasClass(c)) {
      t.removeClass(c);
      f && f();
    } else {
      t.addClass(c);
      s && s();
    }
  }

  function animateNavs($contain, $item = ".mob-nav-item") {
    $contain.find($item).each(function (idx) {
      const targets = $(this)[0];
      $(this).css({
        opacity: 0,
        transform: "translateX(60px)",
      });
      anime({
        targets,
        opacity: 1,
        translateX: 0,
        easing: "easeOutExpo",
        delay: (idx + 1) * 30 + 100,
        duration: 200,
      });
    });
  }

  function toggleLock() {
    const $body = $("html, body");
    const lastScrollPosition = $("body").attr("data-current-position");
    const currentScrollPosition = window.scrollY;

    if ($body.hasClass("mobile-menu--opened")) {
      $body.removeClass("mobile-menu--opened");
      window.scrollTo(0, +lastScrollPosition);
    } else {
      $("body").attr("data-current-position", currentScrollPosition);
      $body.addClass("mobile-menu--opened");
      animateNavs($(".header-mob-main-nav"));
    }
  }

  function setMobDealNav(label, i) {
    const data = Shopify.eufyV3.header.filter((t) => t.label === label)[0];
    const $dealsNav = $(".header-mob-deals-nav");
    const learn_more = $(".header-mob-deals-nav").data("learn-more");
    let links = "";

    if (!data) return;

    data.links &&
      data.links.map((link, idx) => {
        const paramsVal = `navimenu_${i + 1}_1_${idx + 1}_img`;
        const fullImg =
          link.img_full && data.links.length === 1
            ? `<img class="mob-deals-full-img" src="${link.img_full}" alt="${
                link.alt || link.title
              }" width="688" height="341" />`
            : "";
        links += `<div class="mob-deals-item ${
          link.theme ? `mob-deals-${link.theme}-item` : ""
        }">
                <div class="mob-deals-img-wrap ">
          ${fullImg}
          <img class="mob-deals-img" src="${link.img}" alt="${
          link.alt || link.title
        }" width="342" height="345" />
      </div>
      <div class="mob-deals-info ${
        data.links.length === 1 ? "mob-deals-full-info" : ""
      }">
        <a class="mob-full-link" href="${urlParmsAppend(
          link.href,
          "ref",
          paramsVal
        )}"></a>
        <p class="mob-deals-title">${link.title}</p>
        <a class="is-relative index-btn index-btn-link${
          link.theme ? `-${link.theme}` : ""
        }" href="${urlParmsAppend(link.href, "ref", paramsVal)}">${
          link.btn || learn_more || "Learn More"
        }</a>
      </div>
    </div>`;
      });

    $dealsNav.find(".header-mob-sub-title").text(label);
    $dealsNav.find(".mob-deals-wrap").html(links);
    animateNavs($(".header-mob-deals-nav"), ".mob-deals-item");
  }

  function setMobLinksNav(label, i) {
    const data = Shopify.eufyV3.header.filter((t) => t.label === label)[0];
    const $linksNav = $(".header-mob-links-nav");
    let links = "";

    if (!data) return;

    data.group &&
      data.group.map((group, subidx) => {
        links += `<div class="full-width"><div class="${
          subidx === 0 ? "" : "header-border-line"
        }"><p class="mega-tab-title">${
          group.label || ""
        }</p><ul class="mob-sub-links-list">`;
        group.links &&
          group.links.map((link, linkidx) => {
            const paramsVal = `navimenu_${i + 1}_${subidx + 1}_${
              linkidx + 1
            }_copy`;
            links += `<li class="mob-nav-item">
                  <a class="is-flex is-align-center mob-nav-link" href="${urlParmsAppend(
                    link.href,
                    "ref",
                    paramsVal
                  )}">${link.label}</a>
                </li>`;
          });
        links += `</ul></div></div>`;
      });

    $linksNav.find(".header-mob-sub-title").text(label);
    $linksNav.find(".header-mob-nav-body-inner").html(links);
    animateNavs($linksNav);
  }

  function setMobSubNav(label, i) {
    const data = Shopify.eufyV3.header.filter((t) => t.label === label)[0];
    const $subNav = $(".header-mob-sub-nav");
    let navs = "";
    let links = "";

    if (!data) return;
    Shopify.eufyV3.subNav = data;
    Shopify.eufyV3.subNav.parentIdx = i;

    data.tabs &&
      data.tabs.map((nav, navidx) => {
        navs += `<li class="mob-nav-item" data-idx="${
          navidx + 1
        }" data-mob-sub-nav="${nav.label}">
                <a class="is-relative is-flex is-align-center mob-nav-link mob-link-typeof-tab">
                  <span>${nav.label}</span>
                  ${nav.tag ? `<span class="header-tag">${nav.tag}</span>` : ""}
                </a>
              </li>`;
      });
    data.links &&
      data.links.map((link, idx) => {
        const paramsVal = `navimenu_${i + 1}_${
          data.tabs.length + idx + 1
        }_copy`;
        links += `<li class="mob-nav-item" data-idx="${
          data.tabs.length + idx + 1
        }">
                  <a class="is-flex is-align-center mob-nav-link" href="${urlParmsAppend(
                    link.href,
                    "ref",
                    paramsVal
                  )}">${link.label}</a>
                </li>`;
      });

    $subNav.attr("data-label", label);
    $subNav.find(".header-mob-sub-title").text(label);
    $subNav.find(".mob-sub-link-list").html(navs);
    $subNav.find(".mob-sub-links-list").html(links);
    animateNavs($subNav);
  }

  function setMobThdNav(label, i) {
    const data = Shopify.eufyV3.subNav.tabs.filter((t) => t.label === label)[0];
    const $thdNav = $(".header-mob-thd-nav");
    const { parentIdx } = Shopify.eufyV3.subNav;
    const moreTxt = $thdNav.find(".header-mob-nav-body").data("lang");
    let collects = "";
    let tabs = "";
    let products = "";
    let links = "";
    let more = "";

    if (!data) return;

    $(".mob-nav-product-collect").remove();

    if (data.collects) {
      collects = '<div class="mob-nav-product-collect">';
      collects += '<ul class="mob-nav-collect-list">';
      data.collects.map((item, p_idx) => {
        const paramsVal = `navimenu_${parentIdx + 1}_${i + 1}_${p_idx + 1}_img`;
        let href = urlParmsAppend(item.href, "ref", paramsVal);
        collects += `<li class="mob-nav-product-collect-item">
                    <a ${href && "href=" + href}>
                      <img class="mob-nav-product-collect-img" src="${
                        item.img
                      }" alt="${item.title}" width="160" height="160">
                      <div class="mob-nav-product-info">
                        <p class="mob-nav-product-collect-title">${
                          item.title
                        }</p>
                        <p class="mob-nav-product-collect-description">${
                          item.description
                        }</p>
                      </div>
                    </a>
                  </li>`;
      });
      collects += "</ul>";
      collects += "</div>";
      // $thdNav.find(".header-mob-nav-body").prevAll(".mob-nav-product-collect").remove();
      $thdNav.find(".header-mob-nav-body").before(collects);
    }

    data.tabs &&
      data.tabs.map((subtab, subidx) => {
        const moreLink = subtab.more || data.more;
        links = "";
        more = "";

        tabs += `<li class="swiper-slide mob-product-tab-item ${
          subidx === 0 ? "actived" : ""
        }">${subtab.label}</li>`;

        if (subtab.links) {
          subtab.links.map((item, l_idx) => {
            const paramsVal = `navimenu_${parentIdx + 1}_${i + 1}_${
              subidx + 1
            }_${subtab.list.length + l_idx + 1}_copy`;
            links += `<a class="index-btn index-btn-link" href="${urlParmsAppend(
              item.href,
              "ref",
              paramsVal
            )}">${item.label}</a>`;
          });
        }

        if (moreLink) {
          const linksLen = (subtab.links && subtab.links.length) || 0;
          const paramsVal = `navimenu_${parentIdx + 1}_${i + 1}_${subidx + 1}_${
            subtab.list.length + linksLen + 1
          }_copy`;
          more = `<a class="index-btn index-btn-secondary" href="${urlParmsAppend(
            moreLink,
            "ref",
            paramsVal
          )}">${moreTxt}</a>`;
        }

        if (subtab.list) {
          products += `<div class="mob-nav-product-warpper ${
            subidx === 0 ? "actived" : ""
          }"><ul class="is-flex is-flex-wrap mob-nav-product-list">`;
          subtab.list.map((item, p_idx) => {
            const paramsVal = `navimenu_${parentIdx + 1}_${i + 1}_${
              subidx + 1
            }_${p_idx + 1}_img`;
            products += `<li class="mob-nav-product-item">
                        <a href="${urlParmsAppend(
                          item.href || item.product?.url,
                          "ref",
                          paramsVal
                        )}">
                          <img class="mob-nav-product-img" src="${
                            item.img || item.product?.img
                          }" alt="${
              item.label ||
              item.title ||
              item.product?.alt ||
              item.product?.title
            }" width="160" height="160">
                          <div class="mob-nav-product-info">
                            <p class="mob-nav-product-title">${
                              item.label || item.title || item.product?.title
                            }</p>
                            ${
                              item.tag
                                ? `<p class="mob-nav-product-tag">${item.tag}</p>`
                                : ""
                            }
                          </div>
                        </a>
                      </li>`;
          });
          products += `</ul>
          <div class="mob-nav-collections">
            <div class="mob-nav-product-links">${links}</div>
            <div class="mob-nav-product-more">${more}</div>
          </div>
        </div>`;
        }
      });

    if (data.links) {
      links = "";
      const dataLen = (data.list && data.list.length) || 0;
      data.links.map((item, l_idx) => {
        const paramsVal = `navimenu_${parentIdx + 1}_${i + 1}_${
          dataLen + l_idx + 1
        }_copy`;
        links += `<a class="index-btn index-btn-link" href="${urlParmsAppend(
          item.href,
          "ref",
          paramsVal
        )}">${item.label}</a>`;
      });
    }

    if (data.more) {
      more = "";
      const linkLen = (data.links && data.links.length) || 0;
      const dataLen = (data.list && data.list.length) || 0;
      const paramsVal = `navimenu_${parentIdx + 1}_${i + 1}_${
        dataLen + linkLen + 1
      }_copy`;
      more = `<a class="index-btn index-btn-secondary" href="${urlParmsAppend(
        data.more,
        "ref",
        paramsVal
      )}">${moreTxt}</a>`;
    }

    if (data.list) {
      products += `<div class="mob-nav-product-warpper actived">`;
      products += '<ul class="is-flex is-flex-wrap mob-nav-product-list">';
      data.list.map((item, p_idx) => {
        const paramsVal = `navimenu_${parentIdx + 1}_${i + 1}_${p_idx + 1}_img`;
        products += `<li class="mob-nav-product-item">
                    <a href="${urlParmsAppend(
                      item.href || item.product?.url,
                      "ref",
                      paramsVal
                    )}">
                      <img class="mob-nav-product-img" src="${
                        item.img || item.product?.img
                      }" alt="${
          item.label || item.title || item.product?.alt || item.product?.title
        }" width="160" height="160">
                      <div class="mob-nav-product-info">
                        <p class="mob-nav-product-title">${
                          item.label || item.title || item.product?.title
                        }</p>
                        ${
                          item.tag
                            ? `<p class="mob-nav-product-tag">${item.tag}</p>`
                            : ""
                        }
                      </div>
                    </a>
                  </li>`;
      });
      products += `</ul>
          <div class="mob-nav-collections">
            <div class="mob-nav-product-links">${links}</div>
            <div class="mob-nav-product-more">${more}</div>
          </div>
        </div>`;
    }

    $thdNav.attr("data-label", label);
    $thdNav.find(".header-mob-sub-title").text(label);
    $thdNav.find(".mob-nav-product-contain").html(products);
    if (tabs) {
      $thdNav.find(".mob-product-tab-list").html(tabs).show();
      $thdNav.find(".mob-nav-product-tab").each(function () {
        const targets = $(this)[0];
        $(this).css({
          opacity: 0,
          transform: "translateY(100px)",
        });
        anime({
          targets,
          opacity: 1,
          translateY: 0,
          easing: "easeOutExpo",
          duration: 200,
        });
      });

      if (!mbtabSwiper)
        mbtabSwiper = new Swiper(".mob-nav-product-tab", {
          slidesPerView: "auto",
          freeMode: true,
          observer: true,
        });
    } else {
      mbtabSwiper && mbtabSwiper.removeAllSlides();
      $thdNav.find(".mob-product-tab-list").html("").hide();
    }

    /* if (!collects) {
      $(".mob-nav-product-collect").remove();
    } */

    $thdNav
      .find(".mob-nav-product-item, .mob-nav-product-collect-item")
      .each(function (idx) {
        const targets = $(this)[0];
        $(this).css({
          opacity: 0,
          transform: "translateY(100px)",
        });
        anime({
          targets,
          opacity: 1,
          translateY: 0,
          easing: "easeOutExpo",
          delay: (idx + 1) * 50 + 100,
          duration: 200,
        });
      });
  }

  function urlParmsAppend(href, label, val) {
    if (!href) return "";
    return href.includes("?")
      ? `${href}&${label}=${val}`
      : `${href}?${label}=${val}`;
  }
});

/*============================================================================
Slideshow arrows
==============================================================================*/

if (Shopify.theme_settings.icon_style == "icon_solid") {
  var arrowShape =
    "M95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46z";
} else {
  var arrowShape =
    "M95,48H9.83L41,16.86A2,2,0,0,0,38.14,14L3.59,48.58a1.79,1.79,0,0,0-.25.31,1.19,1.19,0,0,0-.09.15l-.1.2-.06.2a.84.84,0,0,0,0,.17,2,2,0,0,0,0,.78.84.84,0,0,0,0,.17l.06.2.1.2a1.19,1.19,0,0,0,.09.15,1.79,1.79,0,0,0,.25.31L38.14,86A2,2,0,0,0,41,86a2,2,0,0,0,0-2.83L9.83,52H95a2,2,0,0,0,0-4Z";
}
